import { CheckStatus, Parse } from '../utils/ajax';

export default {

    switch(tenantId, authenticationToken) {
        return fetch(`/api/draw/1/authentication/${tenantId}`, {
            headers: {
                Authorization: authenticationToken,
                ManyWhoTenant: tenantId,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    getSubtenants(authenticationToken, tenantId) {
        return fetch('/api/admin/1/tenant/subtenants', {
            headers: {
                Authorization: authenticationToken,
                ManyWhoTenant: tenantId,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    createSubtenant(authenticationToken, tenantId, tenantName) {

        const request = {
            developerName: tenantName,
            developerSummary: '',
        };

        return fetch('/api/admin/1/tenant/subtenants', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: authenticationToken,
                ManyWhoTenant: tenantId,
            },
            body: JSON.stringify(request),
        })
            .then(CheckStatus)
            .then(Parse);
    },

    getCurrent(authenticationToken, tenantId) {
        return fetch('/api/admin/1/tenant/', {
            headers: {
                Authorization: authenticationToken,
                ManyWhoTenant: tenantId,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    updateCurrent(authenticationToken, tenantId, request) {
        return fetch('/api/admin/1/tenant/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: authenticationToken,
                ManyWhoTenant: tenantId,
            },
            body: JSON.stringify(request),
        })
            .then(CheckStatus)
            .then(Parse);
    },

};
